import { NavLink, Route, Routes, useLocation } from "react-router-dom";
import Compliance from "./settings/Compliance";
import KYC from "./settings/KYC";
import Preferences from "./settings/Preferences";
import Profile from "./settings/Profile";
import Security from "./settings/Security";
import EmploymentDetails from "./settings/compliance/EmploymentDetails";
import IDVerification from "./settings/compliance/IDVerification";
import UtilityBill from "./settings/compliance/UtilityBill";
import { useEffect } from "react";
import BankAccounts from "./settings/compliance/BankAccounts";
import UpgradeToTier3 from "./settings/compliance/UpgradeToTier3";
import UpgradeTier2 from "./settings/compliance/UpgradeTier2";
import HomeAddress from "./settings/compliance/HomeAddress";
import TravelDocument from "./settings/compliance/TravelDocument";
import ConfirmResidence from "./signup/ConfirmResidence";

const Settings = () => {
  const location = useLocation();

  const state = location.state as { background?: Location; name?: string };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="flex flex-col">
      <div className="flex items-center p-5 md:px-10 py-4">
        <NavLink
          to="profile"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Profile
        </NavLink>
        <NavLink
          to="security"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Security
        </NavLink>
        <NavLink
          to="compliance"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Compliance
        </NavLink>
        <div className="flex-1"></div>
      </div>
      <Routes location={state?.background || location}>
        <Route index element={<Profile />} />
        <Route path="profile" element={<Profile />} />
        <Route path="security" element={<Security />} />
        <Route path="verification" element={<Profile />} />
        <Route path="preferences" element={<Preferences />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="compliance/kyc" element={<KYC />} />
        <Route
          path="compliance/id-verification"
          element={<IDVerification />}
        />
        <Route
          path="compliance/employment-details"
          element={<EmploymentDetails />}
        />
        <Route path="/compliance/utility-bill" element={<UtilityBill />} />
        <Route path="/compliance/bank-accounts" element={<BankAccounts />} />
        <Route path="/compliance/upgrade-tier-2" element={<UpgradeTier2 />} />
        <Route path="/compliance/upgrade-tier-3" element={<UpgradeToTier3 />} />
        <Route path="/compliance/home-address" element={<HomeAddress />} />
        <Route path="/compliance/travel-document" element={<TravelDocument />} />
        <Route path="/compliance/residence" element={<ConfirmResidence />} />
      </Routes>
    </div>
  );
};

export default Settings;
